module.exports = __webpack_public_path__ + "img/quickbooks.21d8cc60.png";